import {EBreakpoint} from '../../../src/common/scripts/constants';
import type {FixedLengthArray} from '../../../src/common/scripts/types/utils';

const getWindowWidth = (): number => {
    return window.innerWidth || document.documentElement.clientWidth;
};

export const isMobile = (): boolean => {
    return getWindowWidth() < EBreakpoint.DESKTOP;
};

export const pluralWord = (n: number, words: FixedLengthArray<string, 3>): string | undefined => {
    /* eslint-disable  */
    const $i = n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
    /* eslint-enable*/

    return words[$i];
};

// eslint-disable-next-line
export const bodyFixed = (): void =>  {
    const scrollbarShift = `${window.innerWidth - document.body.offsetWidth}px`;
    const scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop;

    document.documentElement.style.setProperty('--scrollbar-shift', scrollbarShift);
    document.documentElement.style.setProperty('--top-position', `${scrollTopPosition}px`);

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.paddingRight = scrollbarShift;
    document.body.style.top = `-${scrollTopPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
};

export const bodyStatic = (): void => {
    const scrollTopPosition = parseInt(document.documentElement.style.getPropertyValue('--top-position') || '0');

    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    document.body.style.width = 'auto';
    document.body.style.paddingRight = '0';
    document.body.style.top = 'auto';
    document.body.style.left = 'auto';
    document.body.style.right = 'auto';

    window.scrollTo(0, scrollTopPosition);

    document.documentElement.style.removeProperty('--scrollbar-shift');
    document.documentElement.style.removeProperty('--top-position');
};

export const convertToDigit = (value: string): string => {
    return Number(value) ? Number(value).toLocaleString('ru-Ru') : value;
};

export const roundToThousands = (num: number, divider: string = '.'): string => {
    return (num / 1_000).toFixed(1).replace('.', divider);
};

export const roundToMillions = (num: number, divider: string = '.'): string => {
    return (num / 1_000_000).toFixed(1).replace('.', divider);
};
